import { render } from "./NoticeDialog.vue?vue&type=template&id=143b928b&scoped=true&ts=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=ts"
export * from "./NoticeDialog.vue?vue&type=script&lang=ts"

import "./NoticeDialog.vue?vue&type=style&index=0&id=143b928b&scoped=true&lang=scss"
import "./NoticeDialog.vue?vue&type=style&index=1&id=143b928b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143b928b"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn});qInstall(script, 'directives', {ClosePopup});
